import { PayloadAction } from "@reduxjs/toolkit";

import { CarsState } from '../../types';

export const setSelectedLocationSharingAutoNumber = (
  state: CarsState,
  action: PayloadAction<CarsState['locationSharing']['selectedAutoNumber']>
) => {
  state.locationSharing.selectedAutoNumber = action.payload
}
